<template>
  <div>
    <a
      href="https://app.zeplin.io/project/5f092773fa16ac9ddd3d2a2f/screen/5f0d0f3c93d4879f0dc42631"
      >Design Draft Buttons & Chips</a
    >
    <h3>Button</h3>
    <div>
      <button class="btn btn-primary mr-1">Primary</button>
      <button class="btn btn-primary mr-1">
        <div>
          <v-icon :style="{ fontSize: '20px' }" color="white" class="mr-2"
            >add</v-icon
          >
          <span>Primary</span>
        </div>
      </button>
      <button class="btn btn-primary mr-1">
        <div>
          <span>Primary</span>
          <v-icon :style="{ fontSize: '20px' }" color="white" class="ml-2"
            >add</v-icon
          >
        </div>
      </button>
      <button class="btn btn-primary mr-1">
        <div>
          <v-icon :style="{ fontSize: '20px' }" color="white" class="mr-2"
            >add</v-icon
          >
          <span>Primary</span>
          <v-icon :style="{ fontSize: '20px' }" color="white" class="ml-3"
            >more_vert</v-icon
          >
        </div>
      </button>
      <button class="btn square">
        <v-icon color="ink-02-medium">delete</v-icon>
      </button>

      <button class="btn circle">
        <v-icon color="ink-02-medium">delete</v-icon>
      </button>
    </div>

    <h3>Button States</h3>
    <div>
      <button class="btn btn-primary">Primary</button>
      <button class="btn btn-primary" disabled>Primary</button>
      <button class="btn btn-outlined">outlined</button>
      <button class="btn btn-outlined" disabled>outlined</button>
      <button class="btn">Basic</button>
      <button class="btn" disabled>Basic</button>
      <button class="btn btn-danger">danger</button>
      <button class="btn btn-danger" disabled>danger</button>

      <div v-ripple>123123</div>
    </div>

    <h3>button-segmented</h3>
    <div>
      <div class="button-segmented relative">
        <button class="btn btn-primary">
          <v-icon :style="{ fontSize: '20px' }" color="white" class="mr-2"
            >add</v-icon
          >
          <span>Button</span>
        </button>
        <button class="btn btn-primary pa-0">
          <v-icon :style="{ fontSize: '20px' }" color="white"
            >arrow_drop_down</v-icon
          >
        </button>
        <div class="button-segmented-menu absolute" style="top: 40px">
          <div class="elevation-6">
            <div class="option">新增單筆資料</div>
            <div class="option">批次匯入CSV</div>
            <div class="option">Option 03</div>
          </div>
        </div>
      </div>

      <div class="pt-16"></div>
      <div class="pt-16"></div>
      <div class="pt-16"></div>
    </div>

    <h3>fab</h3>
    <div>
      <button class="btn-fab btn-fab-add btn-fab-primary" v-ripple>
        <v-icon color="white">add</v-icon>
      </button>
      <button class="btn-fab btn-fab-add" v-ripple>
        <v-icon>add</v-icon>
      </button>
      <div class="btn-fab-wrap">
        <div class="tooltip">Tooltip</div>
        <button class="btn-fab" v-ripple>
          <v-icon color="ink-02-medium">delete</v-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
